import persistReducer from 'redux-persist/es/persistReducer'
import sessionStorage from 'redux-persist/lib/storage/session'
import sessionSlice from '../slices/session.slice'
import { REDUX_PERSIST_CONSTANTS } from '../utils/constants'

/**
 * Session credentials and timers — sessionStorage only (per-tab).
 */
export const sessionPersistConfig = {
  key: REDUX_PERSIST_CONSTANTS.SESSION,
  storage: sessionStorage,
}

export const persistedSessionReducer = persistReducer(
  sessionPersistConfig,
  sessionSlice
)

/** redux-persist key in sessionStorage for the session slice; remove on full logout if needed. */
export const SESSION_SLICE_SESSION_STORAGE_KEY = `persist:${REDUX_PERSIST_CONSTANTS.SESSION}`
